<div class="popup">
  <div class="title" style="margin: 20px 0 0 20px">Add company</div>
  <div class="field-class">
    <span class="field-label">Add company</span>
    <p-dropdown 
      [options]="newCompanyList" 
      [filter]="true"
      filterBy="dispName"
      [showClear]="true"
      displayProperty="id"
      [(ngModel)]="currCompany" 
      [ngModelOptions]="{standalone: true}"
      optionLabel="dispName"
      [virtualScroll]="true" 
      [virtualScrollItemSize]="38"
      (onChange)="onCompanyChange()"
      [style]="{'width': '100%', 'height': '35px', 'font-size': '16px', 'flex-shrink': '0', 'background-color': 'var(--list-bg-color)', 'padding-left': '5px', 'color': 'var(--text-color)'}"
    >
      <ng-template pTemplate="selectedItem" let-selectedOption >
        <div style="margin-top: -6px;" [attr.disabled]="currCompany?.disabled ? true : null">
          {{ getCompanyName(currCompany) }}
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <div *ngIf="currCompany">
    <div class="vessels-title-container">
      <div class="title">Vessels</div>
      <div style="display: flex; font-size: 14px; font-family: Noto Sans JP;">
        <input
          type="checkbox"
          (change)="onSelectAllVesselsChange($event)"
          [checked]="selectAllChecked"
          style="margin-right: 6px; margin-top: 2px"
        >
        Select all vessels
      </div>
    </div>
    <div class="vessel-list">
      <div *ngFor="let vessel of currVesselList" class="vessel-option">
        <input 
          type="checkbox" 
          [value]="vessel.id"
          (change)="onVesselChange($event)" 
          [checked]="isVesselSelected(vessel.id)"
          style="margin-right: 6px; margin-top: 2px"
        >
        {{ vessel.name || vessel.otherName }}
      </div>
    </div>
  </div>
  <div class="button-area flex justify-end">
    <button [mat-dialog-close] class="cancel-button outline-none h-10">Cancel</button>
    <button (click)="saveCompany()" class="save-button h-10 rounded">Save</button>
  </div>
</div>
      